import * as React from "react";
export default React.memo(function SvgSearch20Px(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" role="presentation" {...props}><path d="m19.64 18.36-6.24-6.24a7.52 7.52 0 1 0-1.28 1.28l6.24 6.24ZM7.5 13.4a5.9 5.9 0 1 1 5.9-5.9 5.91 5.91 0 0 1-5.9 5.9Z" /></svg>;
});